module.exports = __webpack_public_path__ + "src/assets/images/accident-management/icon-claim-management.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accident-management/icon-claim-management.jpg
// module id = 2309
// module chunks = 4